import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-static'
import {Badge,Dropdown,DropdownToggle,DropdownMenu,DropdownItem} from 'reactstrap'

export default class AccountMenu extends React.Component {
  constructor(props){
    super(props)
    this.state = {show: false}
  }

  toggle = () => {
    this.setState({show: !this.state.show})
  }

  render() {
    if(this.props.authUser && this.props.authUser.emailVerified) {
      const {account} = this.props
      // const company = account.company || {}
      return(
        <ul className={`list-inline float-${this.props.position} mb-0`}>
          <Dropdown isOpen={this.state.show} toggle={this.toggle} nav={true}>
            <DropdownToggle caret nav={true}>
              {account.name} <i className="fas fa-bars"/>
            </DropdownToggle>
            <DropdownMenu>
              <DropdownItem disabled>
                <h5 className="text-overflow">
                  <small>Willkommen {account.name}</small>
                </h5>
              </DropdownItem>
              <DropdownItem disabled>
                <i className="fas fa-cog"></i> <Link to="/account">Konto / Einstellungen</Link>
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem>
                <i className="fas fa-sign-out-alt"></i> <Link to="/signout">Abmelden</Link>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </ul>
      )
    }
    return <span>'Login'</span>
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/AccountMenu.js